import { Component } from '@angular/core';

@Component({
  selector: 'app-password-confirmation',
  templateUrl: './reset-link-confirmation.component.html',
  styleUrl: './reset-link-confirmation.component.scss'
})
export class ResetLinkConfirmationComponent {

}
